import cnh from '~/helpers/cnh';
import spinnerStyles from '~/styles/spinner.module.css';
import IconLoader from '~icons/tabler/loader';

type Props = {
  className?: string;
};

export default function Spinner({
  className,
}: Props) {
  return (
    <div className={cnh(spinnerStyles.spinner, className ?? '')}>
      <IconLoader />
    </div>
  );
}
